import type { Command } from 'common/Prose/Commands'
import { AllSelection, NodeSelection, TextSelection } from 'prosemirror-state'
import { canSplit } from 'prosemirror-transform'
import { setTrackedChangeCommand } from '../Plugins/TrackChanges/commands'
import { CommandName } from '../Plugins/TrackChanges/commands/types'
import { defaultBlockAt } from './utils'

// NOTICE: Plucked from node_modules/prosemirror-commands/src/commands.js
// :: (EditorState, ?(tr: Transaction)) → bool
// Split the parent block of the selection. If the selection is a text
// selection, also delete its content.
export const splitBlock: Command = (state, dispatch) => {
  let { $from, $to } = state.selection
  if (state.selection instanceof NodeSelection && state.selection.node.isBlock) {
    if (!$from.parentOffset || !canSplit(state.doc, $from.pos)) return false
    if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView())
    return true
  }

  if (!$from.parent.isBlock) return false

  if (dispatch) {
    let atEnd = $to.parentOffset === $to.parent.content.size
    let tr = state.tr
    if (state.selection instanceof TextSelection || state.selection instanceof AllSelection) tr.deleteSelection()
    let deflt = $from.depth === 0 ? undefined : defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)))
    let types = atEnd && deflt ? [{ type: deflt }] : undefined
    let can = canSplit(tr.doc, tr.mapping.map($from.pos), 1, types)
    if (!types && !can && canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [{ type: deflt }] : undefined)) {
      types = deflt ? [{ type: deflt }] : undefined
      can = true
    }
    if (can) {
      tr.split(tr.mapping.map($from.pos), 1, types)
      if (!atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
        let first = tr.mapping.map($from.before()),
          $first = tr.doc.resolve(first)
        if (deflt && $from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt))
          tr.setNodeMarkup(tr.mapping.map($from.before()), deflt)
      }
    }
    setTrackedChangeCommand(tr, { name: CommandName.SPLIT_BLOCK })
    dispatch(tr.scrollIntoView())
  }
  return true
}
